export default __webpack_public_path__ + "static/media/shoppinglist@2x.1bce3dc1.png";